import { render } from "./telebot.vue?vue&type=template&id=7db29f2f"
import script from "./telebot.vue?vue&type=script&lang=js"
export * from "./telebot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__